import { render } from "./TopNotifications.vue?vue&type=template&id=2d04ce26"
import script from "./TopNotifications.vue?vue&type=script&lang=js"
export * from "./TopNotifications.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__